/**
 * 订阅弹窗队列控制器
 *
 * 支持页面上同时存在多个 popup-promotions section，按 delay 升序依次展示。
 * 每个弹窗独立记录关闭状态（sessionStorage key: subscribe-popup-{sectionId}），
 * 关闭当前弹窗后，按 delay 差值等待再展示下一个。
 *
 * 触发时机：用户首次滚动页面时启动队列（与旧版行为一致）。
 */
document.addEventListener("DOMContentLoaded", function () {
  // 多个 section 会重复引入此脚本，仅初始化一次
  if (window.__popupPromotionsInit) return;
  window.__popupPromotionsInit = true;

  const allPopups = Array.from(document.querySelectorAll(".subscribe-popup"));
  let popupQueue = [];
  let queueIndex = 0;
  let queueStarted = false;

  /** 生成每个 section 独立的 sessionStorage key */
  function getStorageKey(sectionId) {
    return `subscribe-popup-${sectionId}`;
  }

  /** 判断弹窗是否已在当前会话中被关闭或提交过 */
  function isDismissed(popupEl) {
    const sectionId = popupEl.dataset.sectionId;
    return !sectionId || !!sessionStorage.getItem(getStorageKey(sectionId));
  }

  /** 构建待展示队列：过滤已关闭项，按 delay 升序排列 */
  function buildQueue() {
    return allPopups
      .filter(function (popupEl) {
        return popupEl.dataset.sectionId && popupEl.dataset.autoShow !== "false" && !isDismissed(popupEl);
      })
      .sort(function (a, b) {
        return (Number(a.dataset.delay) || 0) - (Number(b.dataset.delay) || 0);
      });
  }

  /** 跳过队列中已被关闭的弹窗（如关闭后 index 已递增但中间项被标记 dismissed） */
  function skipDismissedInQueue() {
    while (queueIndex < popupQueue.length && isDismissed(popupQueue[queueIndex])) {
      queueIndex++;
    }
  }

  /**
   * 展示队列中当前 index 对应的弹窗
   * @param {boolean} afterClose - true 表示上一个弹窗刚关闭，等待时间为 delay 差值；false 表示首次展示，等待完整 delay
   */
  function showNextInQueue(afterClose) {
    skipDismissedInQueue();
    if (queueIndex >= popupQueue.length) return;

    const popupEl = popupQueue[queueIndex];
    let waitMs;

    if (!afterClose) {
      waitMs = Number(popupEl.dataset.delay) || 0;
    } else {
      const prevDelay = Number(popupQueue[queueIndex - 1].dataset.delay) || 0;
      const currentDelay = Number(popupEl.dataset.delay) || 0;
      waitMs = Math.max(0, currentDelay - prevDelay);
    }

    setTimeout(function () {
      skipDismissedInQueue();
      if (queueIndex >= popupQueue.length) return;

      const el = popupQueue[queueIndex];
      if (isDismissed(el) || el.classList.contains("active")) return;

      el.classList.add("active");
    }, waitMs);
  }

  /** 关闭弹窗、记录 dismissed 状态，并尝试展示队列中的下一个 */
  function closePopup(popupEl) {
    const sectionId = popupEl.dataset.sectionId;
    if (!sectionId) return;

    popupEl.classList.remove("active");
    sessionStorage.setItem(getStorageKey(sectionId), "true");
    queueIndex++;
    showNextInQueue(true);
  }

  allPopups.forEach(function (popupEl) {
    const sectionId = popupEl.dataset.sectionId;
    if (!sectionId) return;

    const storageKey = getStorageKey(sectionId);
    const formId = `subscribePopup-${sectionId}`;

    popupEl.querySelector(".subscribe-popup__overlay")?.addEventListener("click", function (e) {
      if (!e.target.classList.contains("subscribe-popup__overlay")) return;
      closePopup(popupEl);
    });

    popupEl.querySelector(".subscribe-popup-box-close")?.addEventListener("click", function () {
      closePopup(popupEl);
    });

    // 表单提交成功后 Shopify 会重定向回当前页并带上 hash，此时直接展示成功态
    if (
      location.search.includes("customer_posted=true") &&
      location.hash === `#${formId}`
    ) {
      sessionStorage.setItem(storageKey, "true");
      popupEl.classList.add("active");
    }
  });

  // 首次滚动时启动弹窗队列
  window.addEventListener("scroll", function () {
    if (queueStarted) return;
    queueStarted = true;

    popupQueue = buildQueue();
    queueIndex = 0;
    if (popupQueue.length === 0) return;

    showNextInQueue(false);
  }, { passive: true });
});
